module.exports = __webpack_public_path__ + "img/tokelau.30c63222.svg";